import React, {useCallback} from 'react'
import {CFComponentProps} from 'module/CustomField/type/CFComponentType'
import {CFValue} from 'module/CustomField/type/CFType'
import {getReactSelectDefaultProps, ReactSelectMultiValueCustomizationCSS} from 'config/react-select'
import {selEntryDescAllIds, selEntryDescById} from 'module/edesc/selector/EntryDescSelector'
import {useSelector} from 'react-redux'
import {useMultiValue} from 'module/CustomField/component/util/MultiInputUtil'
import {Perm, TypePerm} from 'module/edesc/TypePerm'
import Select, {components, SelectComponentsConfig} from 'react-select'
import {createEntryDescSelectDatasource} from 'module/edesc/util/createEntryDescSelectDatasource'
import {getEntryDescStyleObj} from 'module/edesc/EntryDescUtil'
import {EntryDesc} from 'generated/JavaTOmodifications'
import {GroupBase} from 'react-select/dist/declarations/src/types'

const customComponents: SelectComponentsConfig<EntryDesc, true, GroupBase<EntryDesc>> = {
	MultiValueContainer: ({children, ...props}) => (
		<components.MultiValueContainer {...props}>
			<div style={{
				...getEntryDescStyleObj(props.data),
				...ReactSelectMultiValueCustomizationCSS,
			}}>
				{children}
			</div>
		</components.MultiValueContainer>
	),
	MultiValueLabel: ({children, ...props}) => (
		<components.MultiValueLabel {...props}>
			<span style={getEntryDescStyleObj(props.data)}>
			{children}
			</span>
		</components.MultiValueLabel>
	),
	Option: ({children, ...props}) => (
		<div style={props.isFocused ? undefined : getEntryDescStyleObj(props.data)}>
			<components.Option {...props}>
				{children}
			</components.Option>
		</div>
	),
}


export function CustomFieldEntryDescriptionMultiComponent(props: CFComponentProps<CFValue>) {
	const {
		cfDef,
		setCb,
		modelValue,
		disabled,
	} = props
	const entryDescAllIds = useSelector(selEntryDescAllIds)
	const entryDescById = useSelector(selEntryDescById)
	const entryDescs = entryDescAllIds.flatMap(id => {
		const ed = entryDescById[(id as unknown as number)]
		return TypePerm.check(ed, Perm.rd, false) ? [ed] : []
	})
	const entryDescsGrouped = createEntryDescSelectDatasource(entryDescs)
	const {valueList, onChange} = useMultiValue(cfDef, modelValue ? modelValue + '' : null, setCb, disabled)
	valueList.sort((a, b) => entryDescAllIds.indexOf(+a) - entryDescAllIds.indexOf(+b))
	const value = valueList.flatMap(id => {
		const ed = entryDescById[+id]
		return ed ? [ed] : []
	})

	return <div className={'CustomFieldEntryDescriptionMultiComponent'}>
		<Select
			{...getReactSelectDefaultProps<EntryDesc, true>({
				components: customComponents,
				isDisabled: disabled,
				isMulti: true,
				isClearable: true,
				tabSelectsValue: true,
				closeMenuOnSelect: false,
				options: entryDescsGrouped,
				value: value,
				onChange: useCallback((value, {action}) =>
						onChange(value.map((v: EntryDesc) => ({
							value: v.id + '',
							label: v.label,
						})), {action}),
					[onChange]),
				getOptionValue: ed => ed.id + '',
				getOptionLabel: ed => ed.label,
			})}
		/>
	</div>
}